import { ValidateJSModel } from 'forms/shared/types';
import address from 'forms/shared/validators/models/location/models/address';
import phoneModelValidator from 'forms/shared/validators/models/phone/phone';
import { hasYesOrNo } from 'models/validate';
import { countryString } from '../../../../../validators/location';
import { PhysicalAddressModel } from './types';

const physicalAddress: ValidateJSModel<PhysicalAddressModel> = {
  HasDifferentAddress: (value, attributes, attributeName, options) => {
    if (options.militaryAddress === false || countryString(options.country) === 'United States') { return {}; }

    return {
      presence: true,
      hasValue: { validator: hasYesOrNo },
    };
  },

  Address: (value, attributes, attributeName, options) => {
    if (options.militaryAddress === false || attributes.HasDifferentAddress?.value === 'Yes') {
      return {
        presence: true,
        location: { ...options, validator: address },
      };
    }

    return {};
  },

  Telephone: (value, attributes, attributeName, options) => {
    // Employment is one of the few (if not the only) sections that has
    // addresses with telephone numbers in the data model.
    if (options?.requireTelephone) {
      if (attributes.HasDifferentAddress?.value === 'Yes') {
        return {
          presence: false, // Telephone is optional
          model: { validator: phoneModelValidator, requireNumber: true },
        };
      }
    }

    return {};
  },
};

export default physicalAddress;
